import React, { useEffect, useMemo, useState } from 'react';
import GestionDroitsPilotageApi from '../api/GestionDroitsPilotageApi';
import '../fichierCss/GestionDroitsPilotage.css';

const ROLES = ['Utilisateur', 'Administrateur'];

const GestionDroitsPilotageContainer = () => {
  const [membres, setMembres] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');
  const [messageSucces, setMessageSucces] = useState('');
  const [majEnCours, setMajEnCours] = useState({});

  const chargerMembres = async () => {
    setChargement(true);
    setErreur('');

    try {
      const data = await GestionDroitsPilotageApi.listerMembres();
      setMembres(Array.isArray(data) ? data : []);
    } catch (error) {
      setErreur(error?.message || 'Impossible de charger les droits des membres.');
      setMembres([]);
    } finally {
      setChargement(false);
    }
  };

  useEffect(() => {
    chargerMembres();
  }, []);

  const membresTries = useMemo(() => {
    return [...membres].sort((a, b) => {
      const nomA = `${a?.nom || a?.Nom || ''} ${a?.prenom || a?.Prenom || ''}`.trim();
      const nomB = `${b?.nom || b?.Nom || ''} ${b?.prenom || b?.Prenom || ''}`.trim();
      return nomA.localeCompare(nomB, 'fr', { sensitivity: 'base' });
    });
  }, [membres]);

  const gererChangementRole = async (id, nouveauRole) => {
    setMessageSucces('');
    setErreur('');
    setMajEnCours((etat) => ({ ...etat, [id]: true }));

    try {
      await GestionDroitsPilotageApi.modifierRolePilotage(id, nouveauRole);

      setMembres((etat) => etat.map((membre) => {
        if ((membre?.id || membre?.Id) === id) {
          return { ...membre, rolePilotage: nouveauRole, RolePilotage: nouveauRole };
        }

        return membre;
      }));

      setMessageSucces('Role mis a jour avec succes.');
    } catch (error) {
      setErreur(error?.message || 'La mise a jour du role a echoue.');
    } finally {
      setMajEnCours((etat) => ({ ...etat, [id]: false }));
    }
  };

  return (
    <section className="gestion-droits-page">
      <div className="gestion-droits-shell">
        <header className="gestion-droits-header">
          <p className="gestion-droits-kicker">Pilotage</p>
          <h1>GestionDroitsPilotage</h1>
          <p>
            Definissez qui peut piloter les pages de pilotage. Un membre peut etre <strong>Utilisateur</strong> ou <strong>Administrateur</strong>.
          </p>
        </header>

        {messageSucces && <div className="gestion-droits-feedback succes">{messageSucces}</div>}
        {erreur && <div className="gestion-droits-feedback erreur">{erreur}</div>}

        <div className="gestion-droits-table-wrap">
          {chargement ? (
            <div className="gestion-droits-loading">Chargement des droits...</div>
          ) : (
            <table className="gestion-droits-table" aria-label="Table de gestion des droits">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Prenom</th>
                  <th>Structure</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {membresTries.length === 0 ? (
                  <tr>
                    <td colSpan={4}>Aucun membre trouve.</td>
                  </tr>
                ) : (
                  membresTries.map((membre) => {
                    const id = membre?.id || membre?.Id;
                    const role = membre?.rolePilotage || membre?.RolePilotage || 'Utilisateur';
                    const nom = membre?.nom || membre?.Nom || '';
                    const prenom = membre?.prenom || membre?.Prenom || '';
                    const structure = membre?.structure || membre?.Structure || '-';
                    const estMaj = Boolean(majEnCours[id]);

                    return (
                      <tr key={id}>
                        <td>{nom}</td>
                        <td>{prenom}</td>
                        <td>{structure}</td>
                        <td>
                          <select
                            value={role}
                            disabled={estMaj}
                            onChange={(event) => gererChangementRole(id, event.target.value)}
                          >
                            {ROLES.map((optionRole) => (
                              <option key={optionRole} value={optionRole}>{optionRole}</option>
                            ))}
                          </select>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </section>
  );
};

export default GestionDroitsPilotageContainer;
